global.tooltip = (function () {
	function createTooltipMarkup(element, glossary, i) {
		var word = element.innerText;
		var header = word.charAt(0).toUpperCase() + word.slice(1);
		var explanation = searchGlossary(word, glossary);
		var closeButton = 'Stäng';

		if (window.location.href.indexOf('en-gb') > -1) {
			closeButton = 'Close';
		  }

		if (word && explanation && header) {
			element.setAttribute('tabindex', '0');
			element.setAttribute('aria-describedby', 'tooltip-' + i);
			var explanationMarkup = '<span class="tooltip-text tooltip--theme-color" role="tooltip" id="tooltip-"' +
			i +'><span class="tooltip-close">' + closeButton + '</span><span class="tooltip-content"><p class="tooltip-word">' + header + '</p>' +
			explanation + '</span></span>';
			element.insertAdjacentHTML('beforeend', explanationMarkup);
		} else {
			element.classList.remove('tooltip');
		}
	}

	function adjustPosition(tooltip, tooltipText) {
		var bounding = tooltipText.getBoundingClientRect();
		var offsetLeft = bounding.left;
		var offsetRight = bounding.right - window.visualViewport.width;

		if (!isInVerticalViewport(tooltipText)) {
            tooltip.classList.add('tooltip--flipped');
		}
		if (offsetLeft < 0) {
            tooltipText.style.left = 'calc(70% - ' + offsetLeft  + 'px)';
            tooltip.style.setProperty('--left', 'calc(1% - ' + offsetLeft  + 'px)');
		}
		else if (offsetRight > 0) {
            tooltipText.style.left = 'calc(50% - ' + offsetRight  + 'px)';
            tooltip.style.setProperty('--left', 'calc(50% + ' + offsetRight  + 'px)');
		}
	}

    function isInVerticalViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)

        );
    }

	function resetPosition(tooltipText) {
		tooltipText.style.left = '';
		tooltipText.style.top = '';
	}

	function handleTooltipClose(tooltip) {
		var tooltipClose = tooltip.querySelector('.tooltip-close');
		tooltipClose.addEventListener('click', function(e) {
			tooltip.classList.remove("visible")
		});
	}

	function handleTooltipPosition(tooltip) {
		var tooltipText = tooltip.querySelector('.tooltip-text');
		if (tooltipText) {
			tooltip.addEventListener('mouseover', function() { tooltip.classList.add("visible"); adjustPosition(tooltip, tooltipText); });
			tooltip.addEventListener('mouseout', function() { tooltip.classList.remove("visible"); tooltip.classList.remove('tooltip--flipped'); resetPosition(tooltipText); });
		}

		//Handle 'hover' on touch devices
		tooltip.addEventListener('click', function(e)  {
			e.stopPropagation();
			if (e.target.classList.contains("tooltip-close")) {
				tooltip.classList.remove("visible")
				return;
			}
			tooltip.classList.add("visible")
		});

		document.body.addEventListener('click', function() {
			if(tooltip){
				tooltip.classList.remove("visible");
			}
		});
	}
	function trimSpecialCharacters(word) {
		word = word.toLowerCase().trim();
		return word.replace(/[-/\\^$*+?.(),|[\]{}]/g, '');
	}

	function searchGlossary(key, glossary) {
        var keyWord = trimSpecialCharacters(key);
		var glossValues = Object.keys(glossary);
		for (var i = 0; i < glossValues.length; i++) {
			var glossKeys = Object.values(glossary)[i];
			for (var j = 0; j < glossKeys.length; j++) {
                var glossaryKey = trimSpecialCharacters(glossKeys[j]);
				if (glossaryKey === keyWord) {
					return glossValues[i];
				}
			}
		}
		return;
	}

	var updateTooltipDict = function () {
		var tooltipElements = document.querySelectorAll('.tooltip');
		var dictionaryElement = document.querySelector('.dictionary');

		var inBrowser = typeof window !== 'undefined';
		var UA = inBrowser && window.navigator.userAgent.toLowerCase();
		var isIE = UA && /msie|trident/.test(UA);

		if (tooltipElements.length > 0) {
			for (var i = 0; i < tooltipElements.length; i++) {
				var tooltip = tooltipElements[i];
				if (isIE) {
					tooltip.classList.remove('tooltip');
				}
				else if (dictionaryElement) {
					var glossary = JSON.parse(dictionaryElement.dataset.dictionary);
					if(tooltip.querySelector('.tooltip-text'))
					{
						handleTooltipPosition(tooltip);
						handleTooltipClose(tooltip);
					}
					else {
						createTooltipMarkup(tooltip, glossary, i);
						handleTooltipPosition(tooltip);
					}
				}
			}
		}
	};

	updateTooltipDict();

	return {
		updateTooltipDict: updateTooltipDict
	};
})();
